import { render, staticRenderFns } from "./updateSchemaAcquiringSettingsModal.vue?vue&type=template&id=072db4d2&scoped=true"
import script from "./updateSchemaAcquiringSettingsModal.vue?vue&type=script&lang=js"
export * from "./updateSchemaAcquiringSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./updateSchemaAcquiringSettingsModal.vue?vue&type=style&index=0&id=072db4d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072db4d2",
  null
  
)

export default component.exports